import type { ClientEvents } from 'centrifuge'

import { $lang } from '@/shared/lib/i18n'
import { getChannelLang } from '@/widgets/chat/lib'
import { $chatChannel } from '@/widgets/chat/model/model.channel'

import type { ICentrifuge } from './types'

export type { ConnectedContext, DisconnectedContext } from 'centrifuge'

export class Centrifuge implements ICentrifuge {
    broadcastServer: BroadcastChannel = new BroadcastChannel('taonga-chat-server-channel')

    eventListeners: Record<keyof ClientEvents, ((ctx: any) => void)[]> = {
        state: [],
        connecting: [],
        connected: [],
        disconnected: [],
        message: [],
        error: [],
        subscribed: [],
        subscribing: [],
        unsubscribed: [],
        publication: [],
        join: [],
        leave: [],
    }

    on(event: keyof ClientEvents, callback: (ctx: any) => void) {
        this.broadcastServer.addEventListener('message', (ctx) => {
            if (event === ctx.data.event) {
                callback(ctx.data.payload)
            }
        })

        this.eventListeners[event].push(callback)

        return this
    }

    connect() {
        const portalLang = $lang.getState()
        const channelLang = getChannelLang($chatChannel.getState())
        const lang = channelLang ?? portalLang

        setTimeout(() => {
            this.eventListeners['subscribed'].forEach((callback) => {
                callback({ channel: 'public:global' })
                callback({ channel: 'public:addme' })
                callback({ channel: `public:lang_${lang}` })
            })
        }, 1000)
    }
    disconnect() {}
}
